import { Transition } from "@headlessui/react";
import { addSeconds } from "date-fns";
import { useState } from "react";
import useWebSocket from "../../hooks/useWebSocket";
import Idle from "./states/Idle";
import Preparing from "./states/Preparing";
import Question from "./states/Question";

export const STATE = {
  // Nothing is happening
  IDLE: 0,
  // Preparing a new round
  PREPARING: 10,
  // A question is being asked
  QUESTION: 20,
  // After the question was answered or the time ran out
  COOLDOWN: 30,
};

let initialState = {
  type: "state",
  state: 20,
  round: {
    start_time: "2021-12-26T12:50:55.152851+00:00",
    question: {
      title:
        "What name is given to the small sac or cavity from which a hair grows?",
      image: null,
      categories: ["Science"],
      hints: [{ blanks: "fo______" }],
    },
  },
  timer: { duration: 60, target: addSeconds(new Date(), 45).toISOString() },
};
if (process.env.NODE_ENV !== "development") {
  initialState = {};
}

const Game = ({ room }) => {
  const [state, setState] = useState(initialState);

  useWebSocket({
    messageType: "state",
    onMessage: (data) => {
      setState(data);
    },
  });

  return (
    <section className="relative bg-gray-50 p-6 flex-1 flex flex-col items-center justify-center overflow-hidden select-none">
      <Transition
        className="absolute"
        appear
        show={state.state === STATE.IDLE || state.state === undefined}
        enter="ease-out duration-1000 transition"
        enterFrom="opacity-0 scale-75"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-75"
      >
        <Idle room={room} ready={state.state !== undefined} />
      </Transition>
      <Transition
        className="absolute"
        show={state.state === STATE.PREPARING}
        enter="ease-out duration-500 transition"
        enterFrom="opacity-0 scale-75"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-250"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-75"
      >
        <Preparing room={room} {...state} />
      </Transition>
      <Transition
        className="absolute w-full h-full"
        show={state.state === STATE.QUESTION || state.state === STATE.COOLDOWN}
        enter="ease-out duration-500 transition"
        enterFrom="opacity-0 scale-75"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-250"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-75"
      >
        <Question room={room} {...state} />
      </Transition>
    </section>
  );
};

export default Game;
